import Repository from "./Repository";

export default {
    saveFile(file, fileName){
        let data = new FormData();
        data.append(fileName, file, file.name);
        
        return Repository.post('upload_file', data);
    }
};
